import { render } from "./courseContentModal.vue?vue&type=template&id=93633dce&ts=true"
import script from "./courseContentModal.vue?vue&type=script&lang=ts"
export * from "./courseContentModal.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__